import React, {} from 'react';
import { Icon } from '../Icon/Icon.js';
import { Spinner } from '../Spinner/Spinner.js';
const styles = {"button":"Button-module__button__lDlt0"};
/**
 * The text button (Components board · Button). Tertiary is the text-link style; sm (36 px) is for desktop inline actions.
 * While loading it shows a spinner and the loading label and cannot be activated.
 */
export function Button({ label, variant = 'primary', size = 'md', iconStart, iconEnd, fullWidth, loading, loadingLabel, disabled, type = 'button', onClick }) {
    const isLoading = loading === true;
    // While loading the button keeps keyboard focus (no native disabled) but ignores activation.
    function handleClick() {
        if (!isLoading) {
            onClick?.();
        }
    }
    const iconSize = size === 'sm' ? 16 : 20;
    let content;
    if (isLoading) {
        content = (React.createElement(React.Fragment, null,
            React.createElement(Spinner, { size: 16 }),
            loadingLabel ?? label));
    }
    else {
        content = (React.createElement(React.Fragment, null,
            iconStart !== undefined && React.createElement(Icon, { name: iconStart, size: iconSize }),
            label,
            iconEnd !== undefined && React.createElement(Icon, { name: iconEnd, size: iconSize })));
    }
    return (React.createElement("button", { className: styles.button, type: type, disabled: disabled === true, "aria-disabled": isLoading ? 'true' : undefined, "aria-busy": isLoading ? 'true' : undefined, "data-variant": variant, "data-size": size, "data-full-width": fullWidth === true ? 'true' : undefined, "data-icon-start": iconStart === undefined ? undefined : 'true', "data-loading": isLoading ? 'true' : undefined, onClick: handleClick }, content));
}
//# sourceMappingURL=Button.js.map